export const COOKIE_NAMES = {
  HISTORY: 'risk_quiz_history'
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const setCookie = (name, value, days = 365) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const getQuizHistory = () => {
  const historyData = getCookie(COOKIE_NAMES.HISTORY);
  if (!historyData) return [];
  try {
    return JSON.parse(decodeURIComponent(historyData));
  } catch (error) {
    console.error('Error parsing quiz history:', error);
    return [];
  }
};

export const saveQuizResult = (riskTolerance, lossAversion, magnitudeSensitivity, totalBets, betTotal) => {
  const history = getQuizHistory();
  const newResult = {
    riskTolerance,
    lossAversion,
    magnitudeSensitivity,
    totalBets,
    betTotal,
    timestamp: Date.now()
  };
  
  history.push(newResult);
  setCookie(COOKIE_NAMES.HISTORY, encodeURIComponent(JSON.stringify(history)));
  return history;
};

export const calculateAllTimeAverages = (history) => {
  if (history.length === 0) return null;
  
  const totals = history.reduce(
    (acc, result) => ({
      riskTolerance: acc.riskTolerance + result.riskTolerance,
      lossAversion: acc.lossAversion + result.lossAversion,
      magnitudeSensitivity: acc.magnitudeSensitivity + result.magnitudeSensitivity,
      betTotal: acc.betTotal + (result.betTotal || 0)
    }),
    { riskTolerance: 0, lossAversion: 0, magnitudeSensitivity: 0, betTotal: 0 }
  );

  return {
    riskTolerance: totals.riskTolerance / history.length,
    lossAversion: totals.lossAversion / history.length,
    magnitudeSensitivity: totals.magnitudeSensitivity / history.length,
    totalQuizzes: history.length,
    totalBets: history.length * 20,
    totalWinnings: totals.betTotal
  };
};